import { useEffect, useState } from "react";
import { fetchBlogs, fetchBlog } from "../lib/api";
import { logError } from "../lib/logger";

export function useBlogs() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        fetchBlogs()
            .then((data) => {
                if (mounted) {
                    setPosts(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                logError("Blogs fetch failed:", err);
                if (mounted) setLoading(false);
            });
        return () => {
            mounted = false;
        };
    }, []);

    return { posts, loading };
}

export function useBlog(slug) {
    const [post, setPost] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        let mounted = true;
        setPost(null);
        setError(false);
        fetchBlog(slug)
            .then((data) => {
                if (mounted) setPost(data);
            })
            .catch((err) => {
                logError("Blog fetch failed:", err);
                if (mounted) setError(true);
            });
        window.scrollTo({ top: 0 });
        return () => {
            mounted = false;
        };
    }, [slug]);

    return { post, error };
}
